export default "__VITE_ASSET__DjBRyKxA__"